export default
{
    code:'BUS_US_EXPERIAN',
    currencies: ['USD','NZD','EUR'],
    content:{
        logo: {
            link: 'https://www.experian.com/'
        },
        menu: {
            menuIconColor: true,
            url: 'https://www.experian.com/',
            business: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
            individual: {
                items: ['dashboard', 'myCalculator', 'projects', 'FAQ', 'myAccount']
            },
        },
        myMovementPanel: {
            hideMovementInvitation: true,
            hideMovementCreation: true,
        },
        signIn: {
            individual: {
                hideSocialMedia: true,
            }
        },
    },
}
